import React from "react";
import { ImageListItem } from "@mui/material";

const DSImageListItem = (props: React.ComponentProps<typeof ImageListItem>) => {
  return <ImageListItem {...props} />;
};

export default DSImageListItem;
